export const USER_SERVICE_STATUS = {
  REMOVED: 'removed',
  PENDING: 'pending',
  RESCHEDULED: 'rescheduled',
  EXECUTING: 'executing',
  CANCELED: 'canceled',
  DONE: 'done'
}

export const USER_SERVICE_STATUS_OPTIONS = [
  {
    value: USER_SERVICE_STATUS.PENDING,
    label: 'Pendiente'
  },
  {
    value: USER_SERVICE_STATUS.RESCHEDULED,
    label: 'Reprogramado'
  },
  {
    value: USER_SERVICE_STATUS.EXECUTING,
    label: 'En ejecución'
  },
  {
    value: USER_SERVICE_STATUS.CANCELED,
    label: 'Cancelado'
  },
  {
    value: USER_SERVICE_STATUS.DONE,
    label: 'Finalizado'
  }
]
